import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{attrs:{"color":"blue darken-1","text":""}},[_c(VIcon,{staticClass:"mr-1"},[_vm._v("mdi-delete")]),_vm._v(" "+_vm._s(_vm.$t('delete'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }